const scoreFilterJson = {
  /** 心输出量 */
  'Cardiac Output': [
    {
      key: 'L/min',
      scale: 1
    }
  ],
  /** 心脏指数 */
  'Cardiac Index': [
    {
      key: 'L/min/m<sup>2</sup>',
      scale: 1
    }
  ],
  'RSBI.result': [
    {
      key: 'L <sup>-1</sup>min <sup>-1</sup>',
      scale: 1
    }
  ],
  /** 静脉补液  - 时间换算 */
  'flow.perfusionrate': [
    {
      key: 'mL/h',
      scale: 1
    },
    {
      key: 'mL/24h',
      scale: 24
    }
  ],
  /** AaGradientAndRatio  - 肺泡-动脉氧分压差及比值 */
  'pressure.bloodgas': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      scale: 1
    },
    {
      key: 'kPa',
      zhName: '千帕',
      scale: 0.13328
    }
  ],
  /** TargetHeight --  理想身高 */
  'length.bodyheight.adult.centimeter,meter,feet+inch': [
    {
      key: 'm',
      zhName: '米',
      scale: 1
    },
    {
      key: 'cm',
      zhName: '厘米',
      scale: 100
    }
  ],
  /** BowelLength --  消化道长度估算 */

  'length.bodyheight.adult.centimeter': [
    {
      key: 'cm',
      zhName: '厘米',
      scale: 1
    }
  ],
  /** OxygenTankRemainingTime  -- 氧气瓶剩余时间 */
  'periodoftime.hour+minute,minute': [
    {
      key: 'min',
      zhName: '分钟',
      scale: 1
    }
  ],
  // 能量单位
  energy: [
    {
      key: 'kcal',
      zhName: '千卡',
      scale: 1
    },
    {
      key: 'cal',
      zhName: '卡',
      scale: 1000
    },
    {
      key: 'j',
      zhName: '焦耳',
      scale: 4184
    },
    {
      key: 'kj',
      zhName: '千焦',
      scale: 4.184
    },
    {
      key: 'MJ',
      zhName: '兆焦',
      scale: 0.004184
    }
  ],
  // 总胆固醇（TC）、高密度脂蛋白胆固醇（HDL-C）、低密度脂蛋白胆固醇（HDL-C）
  tc_hdlc: [
    {
      key: 'mmol/L',
      zhName: '',
      scale: 1
    },
    {
      key: 'mg/dL',
      zhName: '',
      scale: 38.6
    }
  ],
  tg: [
    {
      key: 'mmol/L',
      zhName: '',
      scale: 1
    },
    {
      key: 'mg/dL',
      zhName: '',
      scale: 88.5
    }
  ],
  // 激素剂量单位
  'hormone.dose': [
    {
      key: '可的松',
      scale: 25
    },
    {
      key: '氢化可的松',
      scale: 20
    },
    {
      key: '泼尼松',
      scale: 5
    },
    {
      key: '泼尼松龙',
      scale: 5
    },
    {
      key: '甲泼尼龙',
      scale: 4
    },
    {
      key: '曲安西龙',
      scale: 4
    },
    {
      key: '倍他米松',
      scale: 0.75
    },
    {
      key: '地塞米松',
      scale: 0.75
    }
  ],
  'ca.seven.four': [
    {
      key: 'kU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'U/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }

  ],
  'homocysteine.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 82.5396,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    }
  ],
  'galactose.unit': [
    {
      key: 'mmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 180.16,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 18.016,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 18.016,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 180.16,
      min: 0,
      title: ''
    }
  ],
  'phenobarbital.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 4.306,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    }
  ],
  'Phenylalanine.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 60.5364,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    }
  ],
  'Pyrrolysine.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 39.1676,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    }
  ],
  'Alanine.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 112.246,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'μg/L',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    }
  ],
  'Alanine.Aminotransferase.unit': [
    {
      key: 'nkat/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μkat/L',
      desc: '有效范围： 任何数值',
      scale: 0.001,
      min: 0,
      title: ''
    },
    {
      key: 'U/L',
      desc: '有效范围： 任何数值',
      scale: 0.06,
      min: 0,
      title: ''
    },
    {
      key: 'IU/L',
      desc: '有效范围： 任何数值',
      scale: 0.06,
      min: 0,
      title: ''
    }

  ],
  'Acetone.unit': [
    {
      key: 'mmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 5.808,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 5.808,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 58.08,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 58.08,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 58.08,
      min: 0,
      title: ''
    }
  ],
  'Valproic.acid.unit': [
    {
      key: 'mmol/L',
      desc: '有效范围： 任何数值',
      scale: 6.9343,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Complement.Component.three.unit': [
    {
      key: 'g/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },

    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },

    {
      key: 'mg/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Complement.Component.four.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 5,
      min: 0,
      title: ''
    },

    {
      key: 'g/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },

    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'mg/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Unsaturated.Iron.Binding.Capacity.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },

    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 0.0558,
      min: 0,
      title: ''
    },
    {
      key: 'μg/dL',
      desc: '有效范围： 任何数值',
      scale: 5.5845,
      min: 0,
      title: ''
    },

    {
      key: 'μg%',
      desc: '有效范围： 任何数值',
      scale: 5.5845,
      min: 0,
      title: ''
    },
    {
      key: 'μg/L',
      desc: '有效范围： 任何数值',
      scale: 55.845,
      min: 0,
      title: ''
    }

  ],
  'Theophylline.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 5.5505,
      min: 0,
      title: ''
    },

    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },

    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'ug/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }

  ],
  'Erythropoietin.unit': [
    {
      key: 'IU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },

    {
      key: 'mIU/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Activated.Partial.Thromboplastin.Time.unit': [
    {
      key: 's',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'sec',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Progesterone.unit': [
    {
      key: 'nmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'pmol/L',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'ng/mL',
      desc: '有效范围： 任何数值',
      scale: 0.3145,
      min: 0,
      title: ''
    },
    {
      key: 'ng/dL',
      desc: '有效范围： 任何数值',
      scale: 31.446,
      min: 0,
      title: ''
    },
    {
      key: 'ng/100mL',
      desc: '有效范围： 任何数值',
      scale: 31.446,
      min: 0,
      title: ''
    },
    {
      key: 'ng%',
      desc: '有效范围： 任何数值',
      scale: 31.446,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 314.46,
      min: 0,
      title: ''
    },
    {
      key: 'ug/L',
      desc: '有效范围： 任何数值',
      scale: 0.3145,
      min: 0,
      title: ''
    }
  ],
  'Cardiac.Troponin.I.unit': [
    {
      key: 'ng/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'pg/mL',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'ng/dL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng/100mL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'ug/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Mean.Corpuscular.Volume.unit': [
    {
      key: 'fL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μm³',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'cu μm',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'cubic μm',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Mean.Corpuscular.Hemoglobin.unit': [
    {
      key: 'fmol',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'fmol/cell',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'pg',
      desc: '有效范围： 任何数值',
      scale: 16.114,
      min: 0,
      title: ''
    },
    {
      key: 'pg/cell',
      desc: '有效范围： 任何数值',
      scale: 16.114,
      min: 0,
      title: ''
    }
  ],
  'Mean.Corpuscular.Hemoglobin.Concentration.unit': [
    {
      key: 'mmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 1.6114,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 1.6114,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 1.6114,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 16.114,
      min: 0,
      title: ''
    },
    {
      key: 'mg/mL',
      desc: '有效范围： 任何数值',
      scale: 16.114,
      min: 0,
      title: ''
    },
    {
      key: '%',
      desc: '有效范围： 任何数值',
      scale: 1.6114,
      min: 0,
      title: ''
    }
  ],
  'Mean.Platelet.Volume.unit': [
    {
      key: 'fL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μm³',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'cu μm',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'cubic μm',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Human.Epididymis.Protein.four.unit': [
    {
      key: 'nmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'pmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Human.Growth.Hormone.unit': [
    {
      key: 'mIU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'ng/mL',
      desc: '有效范围： 任何数值',
      scale: 0.333,
      min: 0,
      title: ''
    },
    {
      key: 'ng/dL',
      desc: '有效范围： 任何数值',
      scale: 33.3,
      min: 0,
      title: ''
    },
    {
      key: 'ng/100mL',
      desc: '有效范围： 任何数值',
      scale: 33.3,
      min: 0,
      title: ''
    },
    {
      key: 'ng%',
      desc: '有效范围： 任何数值',
      scale: 33.3,
      min: 0,
      title: ''
    },
    {
      key: 'μg/L',
      desc: '有效范围： 任何数值',
      scale: 0.333,
      min: 0,
      title: ''
    }
  ],
  'Human.Chorionic.Gonadotropin.unit': [
    {
      key: 'mlU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'IU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mlU/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Pregnancy.Associated.Plasma.Protein.A.unit': [
    {
      key: 'mIU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μIU/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'IU/L',
      desc: '有效范围： 任何数值',
      scale: 0.001,
      min: 0,
      title: ''
    },
    {
      key: 'mIU/mL',
      desc: '有效范围： 任何数值',
      scale: 0.001,
      min: 0,
      title: ''
    }
  ],
  'Lactic.Acid.unit': [
    {
      key: 'mmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 9.008,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 9.008,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 9.008,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 90.08,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 90.08,
      min: 0,
      title: ''
    }
  ],
  'Lactate.Dehydrogenase.unit': [
    {
      key: 'nkat/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μkat/L',
      desc: '有效范围： 任何数值',
      scale: 0.001,
      min: 0,
      title: ''
    },
    {
      key: 'U/L',
      desc: '有效范围： 任何数值',
      scale: 0.06,
      min: 0,
      title: ''
    },
    {
      key: 'IU/L',
      desc: '有效范围： 任何数值',
      scale: 0.06,
      min: 0,
      title: ''
    },
    {
      key: 'μmol/(min*L)',
      desc: '有效范围： 任何数值',
      scale: 0.06,
      min: 0,
      title: ''
    },
    {
      key: 'μmol/(h*L)',
      desc: '有效范围： 任何数值',
      scale: 3.6,
      min: 0,
      title: ''
    },
    {
      key: 'μmol/(h*mL)',
      desc: '有效范围： 任何数值',
      scale: 0.0036,
      min: 0,
      title: ''
    }
  ],
  'Calcitonin.unit': [
    {
      key: 'pmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'pg/mL',
      desc: '有效范围： 任何数值',
      scale: 3.4176,
      min: 0,
      title: ''
    },
    {
      key: 'pg/dL',
      desc: '有效范围： 任何数值',
      scale: 341.76,
      min: 0,
      title: ''
    },
    {
      key: 'pg/100mL',
      desc: '有效范围： 任何数值',
      scale: 341.76,
      min: 0,
      title: ''
    },
    {
      key: 'pg%',
      desc: '有效范围： 任何数值',
      scale: 341.76,
      min: 0,
      title: ''
    },
    {
      key: 'pg/L',
      desc: '有效范围： 任何数值',
      scale: 3417.6,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 3.4176,
      min: 0,
      title: ''
    }
  ],
  'Procalcitonin.unit': [
    {
      key: 'ng/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'ng/dL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng/100mL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'μg/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Haptoglobin.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'g/L',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'mg/mL',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    }
  ],
  'Arginine.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 0.0174,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.0174,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 0.0174,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 0.1742,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 0.1742,
      min: 0,
      title: ''
    }
  ],
  'Macroprolactin.unit': [
    {
      key: 'Fraction',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: '%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    }
  ],
  'Carbamazepine.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 0.0236,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.0236,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 0.0236,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 0.0236,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 0.0236,
      min: 0,
      title: ''
    }
  ],
  'Anti.Cyclic.Citrullinated.Peptide.Antibodies.unit': [
    {
      key: 'U/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'kU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Antidiuretic_Hormone.unit': [
    {
      key: 'pmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'pg/mL',
      desc: '有效范围： 任何数值',
      scale: 1.0842,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 1.0842,
      min: 0,
      title: ''
    },
    {
      key: 'ng/dL',
      desc: '有效范围： 任何数值',
      scale: 0.1084,
      min: 0,
      title: ''
    },
    {
      key: 'ng/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.1084,
      min: 0,
      title: ''
    },
    {
      key: 'ng%',
      desc: '有效范围： 任何数值',
      scale: 0.1084,
      min: 0,
      title: ''
    }
  ],
  'Anti_Streptolysin_O.unit': [
    {
      key: 'U/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'IU/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'kU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'kIU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Anti_Müllerian_Hormone.unit': [
    {
      key: 'pmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'ng/mL',
      desc: '有效范围： 任何数值',
      scale: 0.14,
      min: 0,
      title: ''
    },
    {
      key: 'ng/dL',
      desc: '有效范围： 任何数值',
      scale: 14,
      min: 0,
      title: ''
    },
    {
      key: 'ng/100mL',
      desc: '有效范围： 任何数值',
      scale: 14,
      min: 0,
      title: ''
    },
    {
      key: 'ng%',
      desc: '有效范围： 任何数值',
      scale: 14,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 140,
      min: 0,
      title: ''
    },
    {
      key: 'pg/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Antithrombin_Ⅲ.unit': [
    {
      key: '%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'U/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'kU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Soluble_Fms_like_Tyrosine_Kinase_1.unit': [
    {
      key: 'pg/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'pg/dL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'pg/100mL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'pg%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'pg/L',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Soluble_Transferrin_Receptor.unit': [
    {
      key: 'nmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 0.0085,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.0085,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 0.0085,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 0.085,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 0.085,
      min: 0,
      title: ''
    }
  ],
  'Lymphocyte.unit': [
    {
      key: 'Fraction',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: '%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    }
  ],
  'Lymphocyte_Absolute_Count.unit': [
    {
      key: '10⁹/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'G/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'Gpt/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'cells/L',
      desc: '有效范围： 任何数值',
      scale: 1000000000,
      min: 0,
      title: ''
    },
    {
      key: 'K/μL',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'K/mm³',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'cells/μL',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'cells/mm³',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: '10³/μL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: '10³/mm³',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Squamous_Cell_Carcinoma.unit': [
    {
      key: 'ng/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'ng/dL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng/100mL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'μg/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Dehydroepiandrosterone_Sulfate.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μg/dL',
      desc: '有效范围： 任何数值',
      scale: 36.846,
      min: 0,
      title: ''
    },
    {
      key: 'μg/100mL',
      desc: '有效范围： 任何数值',
      scale: 36.846,
      min: 0,
      title: ''
    },
    {
      key: 'μg%',
      desc: '有效范围： 任何数值',
      scale: 36.846,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 0.3685,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 0.3685,
      min: 0,
      title: ''
    },
    {
      key: 'μg/L',
      desc: '有效范围： 任何数值',
      scale: 368.46,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 0.3685,
      min: 0,
      title: ''
    }

  ],
  'Chloride.unit': [
    {
      key: 'mmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mEq/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Follicle_Stimulating_Hormone.unit': [
    {
      key: 'mIU/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'IU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Digitoxin.unit': [
    {
      key: 'nmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μg/dL',
      desc: '有效范围： 任何数值',
      scale: 0.0765,
      min: 0,
      title: ''
    },
    {
      key: 'μg/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.0765,
      min: 0,
      title: ''
    },
    {
      key: 'μg%',
      desc: '有效范围： 任何数值',
      scale: 0.0765,
      min: 0,
      title: ''
    },
    {
      key: 'μg/L',
      desc: '有效范围： 任何数值',
      scale: 0.07649,
      min: 0,
      title: ''
    },
    {
      key: 'ng/mL',
      desc: '有效范围： 任何数值',
      scale: 0.07649,
      min: 0,
      title: ''
    }
  ],
  // 组氨酸单位
  'histidine': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0155
    },
    {
      key: 'mg/100mL',
      scale: 0.0155
    },
    {
      key: 'mg%',
      scale: 0.0155
    },
    {
      key: 'mg/L',
      scale: 0.1552
    },
    {
      key: 'μg/mL',
      scale: 0.1552
    }
  ],
  // 总铁结合力
  'TIBC': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mmol/L',
      scale: 0.001
    },
    {
      key: 'μg/dL',
      scale: 5.5845
    },
    {
      key: 'μg/100mL',
      scale: 5.5845
    },
    {
      key: 'μg%',
      scale: 5.5845
    },
    {
      key: 'μg/L',
      scale: 55.845
    },
    {
      key: 'ng/mL',
      scale: 55.845
    },
    {
      key: 'mg/L',
      scale: 0.0558
    }
  ],
  // 总蛋白
  'TP': [
    {
      key: 'g/L',
      scale: 1
    },
    {
      key: 'g/dL',
      scale: 0.1
    },
    {
      key: 'g/100mL',
      scale: 0.1
    },
    {
      key: 'g%',
      scale: 0.1
    },
    {
      key: 'mg/mL',
      scale: 1
    }
  ],
  // 总胆红素
  'TBIL': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 58.467
    },
    {
      key: 'm/100mL',
      scale: 58.467
    },
    {
      key: 'mg%',
      scale: 58.467
    },
    {
      key: 'mg/L',
      scale: 584.67
    },
    {
      key: 'μg/mL',
      scale: 584.67
    }
  ],
  // 游离三碘甲状腺原氨酸
  'FT3': [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 0.651
    },
    {
      key: 'pg/100mL',
      scale: 65.1
    },
    {
      key: 'pg%',
      scale: 65.1
    },
    {
      key: 'ng/dL',
      scale: 0.0651
    },
    {
      key: 'ng/gL',
      scale: 0.651
    }
  ],
  // 载脂蛋白A-1
  'Apo_A_1': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'g/L',
      scale: 28
    },
    {
      key: 'mg/dL',
      scale: 2800
    },
    {
      key: 'mg/100mL',
      scale: 2800
    },
    {
      key: 'mg%',
      scale: 2800
    },
    {
      key: 'mg/mL',
      scale: 28
    }
  ],
  // 载脂蛋白B
  'ApoB': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'g/L',
      scale: 513
    },
    {
      key: 'mg/dL',
      scale: 51300
    },
    {
      key: 'mg/100mL',
      scale: 51300
    },
    {
      key: 'mg%',
      scale: 51300
    },
    {
      key: 'mg/mL',
      scale: 513
    }
  ],
  // 脂蛋白(a)
  'LP_a': [
    {
      key: 'g/L',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 100
    },
    {
      key: 'mg/100mL',
      scale: 100
    },
    {
      key: 'mg%',
      scale: 100
    },
    {
      key: 'mg/mL',
      scale: 1
    }
  ],
  // 脂多糖结合蛋白
  'LBP': [
    {
      key: 'μg/mL',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.1
    },
    {
      key: 'mg/100mL',
      scale: 0.1
    },
    {
      key: 'mg%',
      scale: 0.1
    }
  ],
  // 脂肪酶
  'LPS': [
    {
      key: 'U/L',
      scale: 1
    },
    {
      key: 'IU/L',
      scale: 1
    },
    {
      key: 'μmol/（min·L）',
      scale: 1
    },
    {
      key: 'μmol/（h·L）',
      scale: 60
    },
    {
      key: 'μmol/（h·mL）',
      scale: 0.6
    },
    {
      key: 'nkat/L',
      scale: 16.667
    },
    {
      key: 'μkat/L',
      scale: 0.0167
    },
    {
      key: 'nmol/（s·L）',
      scale: 16.667
    },
    {
      key: 'μmol/（s·L）',
      scale: 0.0167
    }
  ],
  // 直接胆红素
  'DBIL': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 58.467
    },
    {
      key: 'mg/100mL',
      scale: 58.467
    },
    {
      key: 'mg%',
      scale: 58.467
    },
    {
      key: 'mg/L',
      scale: 584.67
    },
    {
      key: 'μg/mL',
      scale: 584.67
    }
  ],
  // 中性粒细胞占比
  'NEUT': [
    {
      key: 'Proportion of 1.0',
      scale: 1
    },
    {
      key: 'Fraction',
      scale: 1
    },
    {
      key: '%',
      scale: 100
    }
  ],
  // 转铁蛋白
  'TRF': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'g/L',
      scale: 0.0796
    },
    {
      key: 'mg/dL',
      scale: 7.96
    },
    {
      key: 'mg/100mL',
      scale: 7.96
    },
    {
      key: 'mg%',
      scale: 7.96
    },
    {
      key: 'mg/mL',
      scale: 0.0796
    }
  ],
  // 中性粒细胞计数
  'ANC': [
    {
      key: '10^9/L',
      scale: 1
    },
    {
      key: 'G/L',
      scale: 1
    },
    {
      key: 'Gpt/L',
      scale: 1
    },
    {
      key: '10^9cells/L',
      scale: 1
    },
    {
      key: '10^3/μL',
      scale: 1
    },
    {
      key: '10^3/mm^3',
      scale: 1
    },
    {
      key: 'K/μL',
      scale: 1
    },
    {
      key: 'K/mm^3',
      scale: 1
    },
    {
      key: 'cells/μL',
      scale: 1000
    },
    {
      key: 'cells/mm^3',
      scale: 1000
    }
  ],
  // 总Ⅰ型前胶原氨基端延长肽
  'TP1NP': [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 总胆固醇
  'TC': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 38.665
    },
    {
      key: 'mg/100mL',
      scale: 38.665
    },
    {
      key: 'mg%',
      scale: 38.665
    },
    {
      key: 'mg/L',
      scale: 38.665
    },
    {
      key: 'μg/mL',
      scale: 38.665
    }
  ],
  // 钠
  'Na': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'mEq/L',
      scale: 1
    }
  ],
  // 尿素氮
  'BUN': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/mL',
      scale: 2.8
    },
    {
      key: 'mg/100mL',
      scale: 2.8
    },
    {
      key: 'mg%',
      scale: 2.8
    },
    {
      key: 'mg/L',
      scale: 28
    },
    {
      key: 'μg/mL',
      scale: 28
    }
  ],
  // 尿酸
  'UA': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 16.811
    },
    {
      key: 'mg/100mL',
      scale: 16.811
    },
    {
      key: 'mg%',
      scale: 16.811
    },
    {
      key: 'mg/L',
      scale: 168.11
    },
    {
      key: 'μg/mL',
      scale: 168.11
    }
  ],
  // 血红蛋白
  'HBG': [
    {
      key: 'g/L',
      scale: 1
    },
    {
      key: 'g/dL',
      scale: 0.1
    },
    {
      key: 'g/100mL',
      scale: 0.1
    },
    {
      key: 'g%',
      scale: 0.1
    },
    {
      key: 'mg/mL',
      scale: 1
    }
  ],
  // 血红蛋白单体（亚基）
  'Hemoglobin_subunit': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'g/L',
      scale: 16.114
    },
    {
      key: 'g/dL',
      scale: 1.6114
    },
    {
      key: 'g/100mL',
      scale: 1.6114
    },
    {
      key: 'g%',
      scale: 1.6114
    },
    {
      key: 'mg/mL',
      scale: 16.114
    }
  ],
  // 血红蛋白四聚体
  'Hemoglobin_tetramer': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'g/L',
      scale: 64.458
    },
    {
      key: 'g/dL',
      scale: 6.4458
    },
    {
      key: 'g/100mL',
      scale: 6.4458
    },
    {
      key: 'g%',
      scale: 6.4458
    },
    {
      key: 'mg/mL',
      scale: 64.458
    }
  ],
  // 血细胞比容
  'HCT': [
    {
      key: 'L/L',
      scale: 1
    },
    {
      key: '%',
      scale: 100
    }
  ],
  // 血小板
  'Blood_Platelet': [
    {
      key: '10^9/L',
      scale: 1
    },
    {
      key: 'G/L',
      scale: 1
    },
    {
      key: 'Gpt/L',
      scale: 1
    },
    {
      key: '10^9cells/L',
      scale: 1
    },
    {
      key: '10^3/μL',
      scale: 1
    },
    {
      key: '10^3/mm^3',
      scale: 1
    },
    {
      key: 'K/μL',
      scale: 1
    },
    {
      key: 'K/mm^3',
      scale: 1
    },
    {
      key: 'cells/μL',
      scale: 1000
    },
    {
      key: 'cells/mm^3',
      scale: 1000
    }
  ],
  // 叶酸
  'Folic_Acid': [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    },
    {
      key: 'nmol/L',
      scale: 2.2665
    },
    {
      key: 'pmol/L',
      scale: 2265.5188
    }
  ],
  // 叶酸盐
  'Folate': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'pmol/L',
      scale: 1000
    },
    {
      key: 'ng/mL',
      scale: 0.44
    },
    {
      key: 'ng/dL',
      scale: 44
    },
    {
      key: 'ng/100ml',
      scale: 44
    },
    {
      key: 'ng%',
      scale: 44
    },
    {
      key: 'μg/L',
      scale: 440
    }
  ],
  // 缬氨酸
  'Val': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0117
    },
    {
      key: 'mg/100mL',
      scale: 0.0117
    },
    {
      key: 'mg%',
      scale: 0.0117
    },
    {
      key: 'mg/L',
      scale: 0.117
    },
    {
      key: 'μg/mL',
      scale: 0.1172
    }
  ],
  // 性激素结合球蛋白
  'SHBG': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/mL',
      scale: 0.095
    },
    {
      key: 'μg/dL',
      scale: 9.5
    },
    {
      key: 'μg/100mL',
      scale: 9.5
    },
    {
      key: 'μ%',
      scale: 9.5
    },
    {
      key: 'μg/L',
      scale: 95
    },
    {
      key: 'mg/L',
      scale: 0.095
    }
  ],
  // 促肾上腺皮质激素（ACTH）
  'acth': [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 4.541
    },
    {
      key: 'pg/dL',
      scale: 454.1
    },
    {
      key: 'pg/100mL',
      scale: 454.1
    },
    {
      key: 'pg%',
      scale: 454.1
    },
    {
      key: 'pg/L',
      scale: 4541
    },
    {
      key: 'ng/L',
      scale: 4.541
    }
  ],
  // 催乳素（PRL）
  'Prolactin': [
    {
      key: 'μg/L',
      scale: 1
    },
    {
      key: 'μIUmL',
      scale: 21.2766
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'mIU/L',
      scale: 21.2766
    }
  ],
  // 单核细胞
  'Monocytes': [
    {
      key: 'Proportion of 1.0',
      scale: 1
    },
    {
      key: 'Fraction',
      scale: 1
    },
    {
      key: '%',
      scale: 100
    }
  ],
  // 绝对单核细胞计数
  'Absolute_Monocyte_Count': [
    {
      key: '10^9/L',
      scale: 1
    },
    {
      key: 'G/L',
      scale: 1
    },
    {
      key: 'Gpt/L',
      scale: 1
    },
    {
      key: '10^3/μL',
      scale: 1
    },
    {
      key: 'K/μL',
      scale: 1
    },
    {
      key: 'K/mm^3',
      scale: 1
    },
    {
      key: 'cells/L',
      scale: 1000
    },
    {
      key: 'cells/mm^3',
      scale: 1000
    }
  ],
  // 胆碱酯酶
  'Cholinesterase': [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    }
  ],
  // 蛋氨酸（Met）
  'Methionine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0149
    },
    {
      key: 'mg/100mL',
      scale: 0.0149
    },
    {
      key: 'mg%',
      scale: 0.0149
    },
    {
      key: 'mg/L',
      scale: 0.1492
    },
    {
      key: 'μg/mL',
      scale: 0.1492
    }
  ],
  // 低密度脂蛋白胆固醇（LDL-C）
  'LDL-C': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 38.665
    },
    {
      key: 'mg/100mL',
      scale: 38.665
    },
    {
      key: 'mg%',
      scale: 38.665
    },
    {
      key: 'mg/L',
      scale: 386.65
    },
    {
      key: 'μg/mL',
      scale: 386.65
    }
  ],
  // 地高辛
  'Digoxin': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/L',
      scale: 0.7809
    },
    {
      key: 'μg/dL',
      scale: 0.0781
    },
    {
      key: 'μg/100mL',
      scale: 0.0781
    },
    {
      key: 'μg%',
      scale: 0.0781
    },
    {
      key: 'ng/mL',
      scale: 0.7809
    }
  ],
  // 淀粉酶
  'Amylase': [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    }
  ],
  // 对乙酰氨基酚
  'Acetaminophen': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 0.1512
    },
    {
      key: 'mg/dL',
      scale: 0.0151
    },
    {
      key: 'mg/100mL',
      scale: 0.0151
    },
    {
      key: 'μg/mL',
      scale: 0.1512
    }
  ],
  // 泛酸（维生素B5）
  'Pantothenic_Acid': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 0.2192
    },
    {
      key: 'mg/dL',
      scale: 0.0219
    },
    {
      key: 'mg/100mL',
      scale: 0.0219
    },
    {
      key: 'μg/mL',
      scale: 0.2192
    },
    {
      key: 'mg%',
      scale: 0.0219
    }
  ],
  // 脯氨酸
  'Proline': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 0.1151
    },
    {
      key: 'mg/dL',
      scale: 0.0115
    },
    {
      key: 'mg/100mL',
      scale: 0.0115
    },
    {
      key: 'μg/mL',
      scale: 0.1151
    }
  ],
  // 钙
  'Calcium': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 4.0078
    },
    {
      key: 'mg/100mL',
      scale: 4.0078
    },
    {
      key: 'mg%',
      scale: 4.0078
    },
    {
      key: 'mg/L',
      scale: 40.078
    },
    {
      key: 'μg/mL',
      scale: 40.078
    }
  ],
  // 甘氨酸（Gly）
  'Glycine': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 0.0751
    },
    {
      key: 'mg/dL',
      scale: 0.0075
    },
    {
      key: 'mg/100mL',
      scale: 0.0075
    },
    {
      key: 'μg/mL',
      scale: 0.0751
    },
    {
      key: 'mg%',
      scale: 0.0075
    }
  ],
  // 甘油三酯（TG）
  'Triglycerides': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/L',
      scale: 885.7
    },
    {
      key: 'mg/dL',
      scale: 88.57
    },
    {
      key: 'mg/100mL',
      scale: 88.57
    },
    {
      key: 'μg/mL',
      scale: 885.7
    }
  ],
  // 高密度脂蛋白胆固醇（HDL-C）
  'HDL-C': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 38.665
    },
    {
      key: 'mg/100mL',
      scale: 38.665
    },
    {
      key: 'mg%',
      scale: 38.665
    },
    {
      key: 'mg/L',
      scale: 386.65
    },
    {
      key: 'μg/mL',
      scale: 386.65
    }
  ],
  // 睾酮
  'Testosterone': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.2884
    },
    {
      key: 'ng/dL',
      scale: 28.842
    },
    {
      key: 'ng/100mL',
      scale: 28.842
    },
    {
      key: 'ng%',
      scale: 28.842
    },
    {
      key: 'ng/L',
      scale: 288.42
    },
    {
      key: 'μg/L',
      scale: 0.2884
    }
  ],
  // 谷氨酸
  'Glutamic_Acid': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0147
    },
    {
      key: 'mg/100mL',
      scale: 0.0147
    },
    {
      key: 'mg%',
      scale: 0.0147
    },
    {
      key: 'mg/L',
      scale: 0.1471
    },
    {
      key: 'μg/mL',
      scale: 0.1471
    }
  ],
  // 谷氨酸脱氢酶（GLDH）
  'GLDH': [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'nmol/(S·L)',
      scale: 1
    },
    {
      key: 'umol/(S·L)',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    }
  ],
  // 谷氨酰胺（Gln）
  'Glutamine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0146
    },
    {
      key: 'mg/100mL',
      scale: 0.0146
    },
    {
      key: 'mg%',
      scale: 0.0146
    },
    {
      key: 'mg/L',
      scale: 0.1461
    },
    {
      key: 'μg/mL',
      scale: 0.1461
    }
  ],
  // 骨钙素（OCN）
  'Osteocalcin': [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 同型半胱氨酸（Hcy）
  'Homocysteine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0135
    },
    {
      key: 'mg/100mL',
      scale: 0.0135
    },
    {
      key: 'mg%',
      scale: 0.0135
    },
    {
      key: 'mg/L',
      scale: 0.1352
    },
    {
      key: 'μg/mL',
      scale: 0.1352
    }
  ],
  // 胱氨酸（Cys）
  'Cysteine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.024
    },
    {
      key: 'mg/100mL',
      scale: 0.024
    },
    {
      key: 'mg%',
      scale: 0.024
    },
    {
      key: 'mg/L',
      scale: 0.2403
    },
    {
      key: 'μg/mL',
      scale: 0.2403
    }
  ],
  // 亮氨酸（Leu）
  'Leucine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0131
    },
    {
      key: 'mg/100mL',
      scale: 0.0131
    },
    {
      key: 'mg%',
      scale: 0.0131
    },
    {
      key: 'mg/L',
      scale: 0.1312
    },
    {
      key: 'μg/mL',
      scale: 0.1312
    }
  ],
  // 酪氨酸（Tyr）
  'Tyrosine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0181
    },
    {
      key: 'mg/100mL',
      scale: 0.0181
    },
    {
      key: 'mg%',
      scale: 0.0181
    },
    {
      key: 'mg/L',
      scale: 0.1812
    },
    {
      key: 'μg/mL',
      scale: 0.1812
    }
  ],
  // 赖氨酸
  'Lysine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0146
    },
    {
      key: 'mg/100mL',
      scale: 0.0146
    },
    {
      key: 'mg%',
      scale: 0.0146
    },
    {
      key: 'mg/L',
      scale: 0.1462
    },
    {
      key: 'μg/mL',
      scale: 0.1462
    }
  ],
  // 果糖
  'Fructose': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 18.016
    },
    {
      key: 'mg/100mL',
      scale: 18.016
    },
    {
      key: 'mg%',
      scale: 18.016
    },
    {
      key: 'mg/L',
      scale: 180.16
    },
    {
      key: 'μg/mL',
      scale: 180.16
    }
  ],
  // 纤维蛋白原
  'Fibrinogen': [
    {
      key: 'g/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 100
    },
    {
      key: 'mg/100mL',
      scale: 100
    },
    {
      key: 'mg%',
      scale: 100
    },
    {
      key: 'mg/L',
      scale: 1000
    },
    {
      key: 'μg/mL',
      scale: 1000
    }
  ],
  // 凝血酶时间（TT）
  'Thrombin_Time': [
    {
      key: 's',
      scale: 1
    },
    {
      key: 'sec',
      scale: 1
    }
  ],
  // 凝血酶原时间（PT）
  'Prothrombin_Time': [
    {
      key: 's',
      scale: 1
    },
    {
      key: 'sec',
      scale: 1
    }
  ],
  // 嗜酸性粒细胞
  'Eosinophil': [
    {
      key: 'Fraction',
      scale: 1
    },
    {
      key: '%',
      scale: 100
    }
  ],
  // 嗜酸性粒细胞绝对计数
  'Absolute_Eosinophil_Count': [
    {
      key: '10^9L',
      scale: 1
    },
    {
      key: 'G/L',
      scale: 1
    },
    {
      key: 'Gpt/L',
      scale: 1
    },
    {
      key: 'cells/L',
      scale: 1000000000
    },
    {
      key: 'K/μL',
      scale: 1
    },
    {
      key: 'K/mm^3',
      scale: 1
    },
    {
      key: 'cells/L',
      scale: 1000
    },
    {
      key: 'cells/mm^3',
      scale: 1000
    }
  ],
  // 嗜酸性粒细胞阳离子蛋白（ECP）
  'Eosinophil_Cationic_Protein': [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 嗜碱性粒细胞（嗜碱性粒细胞绝对计数）
  'Basophil_Absolute_Count': [
    {
      key: '10^9L',
      scale: 1
    },
    {
      key: 'G/L',
      scale: 1
    },
    {
      key: 'Gpt/L',
      scale: 1
    },
    {
      key: 'cells/L',
      scale: 1000000000
    },
    {
      key: 'K/μL',
      scale: 1
    },
    {
      key: 'K/mm^3',
      scale: 1
    },
    {
      key: 'cells/L',
      scale: 1000
    },
    {
      key: 'cells/mm^3',
      scale: 1000
    }
  ],
  // 嗜碱性粒细胞
  'Basophils': [
    {
      key: 'Fraction',
      scale: 1
    },
    {
      key: '%',
      scale: 100
    }
  ],
  // 免疫球蛋白G（IgG）
  'Immunoglobulin_G': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 97.1
    },
    {
      key: 'mg/100mL',
      scale: 97.1
    },
    {
      key: 'mg%',
      scale: 97.1
    },
    {
      key: 'g/L',
      scale: 0.971
    },
    {
      key: 'mg/mL',
      scale: 0.971
    }
  ],
  // 葡萄糖
  'Glucose': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/L',
      scale: 180.16
    },
    {
      key: 'mg/dL',
      scale: 18.016
    },
    {
      key: 'mg/100mL',
      scale: 18.016
    },
    {
      key: 'μg/mL',
      scale: 180.16
    }
  ],
  // 前白蛋白（PA）
  'Prealbumin': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'g/dL',
      scale: 5.5
    },
    {
      key: 'g/100mL',
      scale: 5.5
    },
    {
      key: 'g%',
      scale: 5.5
    },
    {
      key: 'mg/mL',
      scale: 0.055
    },
    {
      key: 'g/L',
      scale: 0.055
    }
  ],
  // 前列腺特异性抗原（PSA）
  'Prostate_Specific_Antigen': [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 庆大霉素
  'Gentamicin': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0478
    },
    {
      key: 'mg/100mL',
      scale: 0.0478
    },
    {
      key: 'mg%',
      scale: 0.0478
    },
    {
      key: 'mg/L',
      scale: 0.478
    },
    {
      key: 'μg/mL',
      scale: 0.4776
    }
  ],
  // 利多卡因
  'Lidocaine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0234
    },
    {
      key: 'mg/100mL',
      scale: 0.0234
    },
    {
      key: 'mg%',
      scale: 0.0234
    },
    {
      key: 'mg/L',
      scale: 0.2343
    },
    {
      key: 'μg/mL',
      scale: 0.2343
    },
    {
      key: '%溶液',
      scale: 0.234
    }
  ],
  // 胱抑素C（Cys C）
  'Cystatin_C': [
    {
      key: 'mg/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.1
    },
    {
      key: 'mg/100mL',
      scale: 0.1
    },
    {
      key: 'mg%',
      scale: 0.1
    },
    {
      key: 'μg/mL',
      scale: 1
    }
  ],
  // 肌红蛋白（Mb）
  'Myoglobin': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 17.5
    },
    {
      key: 'ng/dL',
      scale: 1750
    },
    {
      key: 'ng/100mL',
      scale: 1750
    },
    {
      key: 'ng%',
      scale: 1750
    },
    {
      key: 'ng/L',
      scale: 17500
    },
    {
      key: 'μg/L',
      scale: 17.5
    }
  ],
  // 肌酸激酶（CK）
  'Creatine_Kinase': [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'nmol/(s·L)',
      scale: 1
    },
    {
      key: 'umol/(s·L)',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    }
  ],
  // 甲状旁腺激素（PTH）
  'parathyroid_hormone': [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 9.43
    },
    {
      key: 'pg/dL',
      scale: 943
    },
    {
      key: 'pg/100mL',
      scale: 943
    },
    {
      key: 'pg%',
      scale: 943
    },
    {
      key: 'pg/L',
      scale: 9430
    },
    {
      key: 'ng/L',
      scale: 9.43
    }
  ],
  // 甲状腺过氧化物酶抗体（Anti-TPO）
  'Antithyroid_peroxidase_antibody': [
    {
      key: 'IU/mL',
      scale: 1
    },
    {
      key: 'kIU/L',
      scale: 1
    }
  ],
  // 甲状腺球蛋白（Tg）
  'Thyroglobulin': [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 甲状腺球蛋白抗体（Anti-Tg）
  'Anti_Thyroglobulin_Antibodies': [
    {
      key: 'kIU/L',
      scale: 1
    },
    {
      key: 'IU/mL',
      scale: 1
    }
  ],
  // 甲状腺摄取
  'Thyroid_Uptake': [
    {
      key: 'Proportion of 1.0',
      scale: 1
    },
    {
      key: '%',
      scale: 1
    }
  ],
  // 甲状腺素（TT4）
  'Total_Thyroxine': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.0777
    },
    {
      key: 'μg/100mL',
      scale: 0.0777
    },
    {
      key: 'μg%',
      scale: 0.0777
    },
    {
      key: 'μg/L',
      scale: 0.7769
    },
    {
      key: 'ng/mL',
      scale: 0.7769
    }
  ],
  // 醛固酮
  'Aldosterone': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.3605
    },
    {
      key: 'ng/dL',
      scale: 36.045
    },
    {
      key: 'ng/100mL',
      scale: 36.045
    },
    {
      key: 'ng%',
      scale: 36.045
    },
    {
      key: 'ng/L',
      scale: 360.45
    },
    {
      key: 'pg/mL',
      scale: 360.45
    }
  ],
  // 醛缩酶（ALD）
  'Aldolase': [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    },
    {
      key: 'nmol/(s·L)',
      scale: 1
    },
    {
      key: 'μmol/(s·L)',
      scale: 0.001
    }
  ],
  // 果糖胺
  'Fructosamine': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    }
  ],
  // 核黄素（维生素B2）
  'Riboflavin': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.0376
    },
    {
      key: 'μg/100mL',
      scale: 0.0376
    },
    {
      key: 'μg%',
      scale: 0.0376
    },
    {
      key: 'μg/L',
      scale: 0.3764
    },
    {
      key: 'ng/mL',
      scale: 0.3764
    }
  ],
  // 红细胞分布宽度标准差（RDW-SD）
  'Red_Cell_Distribution_Width_Standard_Deviation': [
    {
      key: 'fL',
      scale: 1
    },
    {
      key: 'μm^3',
      scale: 1
    }
  ],
  // 红细胞分布宽度变异系数（RDW-CV）
  'Red_Cell_Distribution_Width': [
    {
      key: 'Proportion of 1.0',
      scale: 1
    },
    {
      key: '%',
      scale: 100
    }
  ],
  // 甲状腺素结合球蛋白（TBG）
  'Thyroxine_binding_Globulin': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/mL',
      scale: 0.054
    },
    {
      key: 'μg/L',
      scale: 54
    },
    {
      key: 'mg/L',
      scale: 0.054
    },
    {
      key: 'mg/dL',
      scale: 0.0054
    },
    {
      key: 'mg/100mL',
      scale: 0.0054
    },
    {
      key: 'mg%',
      scale: 0.0054
    }
  ],
  // 钾（K）
  'Potassium': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'mEq/L',
      scale: 1
    }
  ],
  // 碱性磷酸酶（ALP）
  'Alkaline_Phosphatase': [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'nmol/(s·L)',
      scale: 1
    },
    {
      key: 'umol/(s·L)',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    }
  ],
  // 免疫球蛋白M（IgM）
  'Immunoglobulin_M': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 97.1
    },
    {
      key: 'mg/100mL',
      scale: 97.1
    },
    {
      key: 'mg%',
      scale: 97.1
    },
    {
      key: 'g/L',
      scale: 0.971
    },
    {
      key: 'mg/mL',
      scale: 0.971
    }
  ],
  // 癌抗原125（CA125）
  'Cancer_Antigen': [
    {
      key: 'U/mL',
      scale: 1
    },
    {
      key: 'kU/L',
      scale: 1
    }
  ],
  // α1-微球蛋白
  'a1_Microglobulin': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'nmol/L',
      scale: 1000
    },
    {
      key: 'mg/L',
      scale: 30
    },
    {
      key: 'mg/100mL',
      scale: 3
    },
    {
      key: 'μg/mL',
      scale: 30
    }
  ],
  // α1-酸性糖蛋白
  'a1_acid_glycoprotein': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'g/L',
      scale: 40
    },
    {
      key: 'g/dL',
      scale: 4000
    },
    {
      key: 'g/100mL',
      scale: 4000
    },
    {
      key: 'mg/mL',
      scale: 40
    },
    {
      key: 'mg/L',
      scale: 40000
    }
  ],
  // γ轻链
  'Gamma_Light_Chain': [
    {
      key: 'g/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 100
    },
    {
      key: 'mg/100mL',
      scale: 100
    },
    {
      key: 'mg%',
      scale: 100
    },
    {
      key: 'mg/mL',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 1000
    }
  ],
  // k轻链
  'Kappa_Light_Chain': [
    {
      key: 'g/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 100
    },
    {
      key: 'mg/100mL',
      scale: 100
    },
    {
      key: 'mg/mL',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 1000
    }
  ],
  // γ-谷氨酰转肽酶（GGT）
  'Gamma_Glutamyl_Transferase': [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'U/L',
      scale: 0.06
    }
  ],
  // β2-微球蛋白(β2-M)
  'Beta_2_Microglobulin': [
    {
      key: 'nmol/L',
      scale: 84.8176
    },
    {
      key: 'mg/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.1
    },
    {
      key: 'mg/100mL',
      scale: 0.1
    },
    {
      key: 'μg/mL',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 1000
    }
  ],
  // β-羟丁酸
  p_Hydroxybutyrate: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 10.411
    },
    {
      key: 'mg/100mL',
      scale: 10.411
    },
    {
      key: 'mg/L',
      scale: 104.11
    },
    {
      key: 'μg/mL',
      scale: 104.11
    }
  ],
  // β-胶原降解产物（Ⅰ型胶原降解产物）
  p_C_telopeptides_of_type_I_collagen: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'pg/mL',
      scale: 1000
    }
  ],
  // α1-抗胰蛋白酶（α1-AT）
  a1_antitrypsin: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 100
    },
    {
      key: 'g/L',
      scale: 54.35
    },
    {
      key: 'g/dL',
      scale: 5435
    },
    {
      key: 'g/100mL',
      scale: 5435
    },
    {
      key: 'mg/mL',
      scale: 54.35
    }
  ],
  // TSH受体抗体（Anti-TSHR）
  TSHR_antibodies: [
    {
      key: 'IU/L',
      scale: 1
    },
    {
      key: 'KIU/L',
      scale: 1
    }
  ],
  // 促甲状腺激素（TSH）
  Thyroid_Stimulating_Hormone: [
    {
      key: 'μU/mL',
      scale: 1
    },
    {
      key: 'mIU/L',
      scale: 1
    }
  ],
  // S100蛋白
  S100_protein: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // N末端B型利钠肽原（NT-proBNP）
  N_terminal_pro_B_type_natriuretic_peptide: [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 8.457
    },
    {
      key: 'pg/dL',
      scale: 845.7
    },
    {
      key: 'pg/100mL',
      scale: 845.7
    },
    {
      key: 'pg%',
      scale: 845.7
    },
    {
      key: 'pg/L',
      scale: 8457
    },
    {
      key: 'ng/L',
      scale: 8.457
    }
  ],
  // N1-甲基烟酰胺（烟酸代谢物）
  N1_methylnicotinamide: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.1372
    },
    {
      key: 'μg/L',
      scale: 0.1372
    },
    {
      key: 'μg/dL',
      scale: 0.0137
    },
    {
      key: 'μg/100mL',
      scale: 0.0137
    },
    {
      key: 'μg%',
      scale: 0.0137
    }
  ],
  // N-乙酰普鲁卡因酰胺（NAPA）
  N_Acetylprocainamide: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'μg/mL',
      scale: 0.2774
    },
    {
      key: 'mg/L',
      scale: 0.2774
    },
    {
      key: 'mg/dL',
      scale: 0.0277
    },
    {
      key: 'mg/100mL',
      scale: 0.0277
    },
    {
      key: 'mg%',
      scale: 0.0277
    }
  ],
  // C肽
  C_Peptide: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'pmol/L',
      scale: 1000
    },
    {
      key: 'ng/mL',
      scale: 3.0203
    },
    {
      key: 'ng/dL',
      scale: 302.029
    },
    {
      key: 'ng/100mL',
      scale: 302.029
    },
    {
      key: 'ng%',
      scale: 302.029
    },
    {
      key: 'ng/L',
      scale: 3020.29
    },
    {
      key: 'μg/L',
      scale: 3.0203
    }
  ],
  // CK-MB质量（定量检测）
  CK_MB_Mass: [
    {
      key: 'μg/L',
      scale: 1
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    }
  ],
  // CK-MB（活性）
  CK_MB_Activity: [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(s*L)',
      scale: 0.001
    },
    {
      key: 'μmol/(min*L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h*L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h*mL)',
      scale: 0.0036
    }
  ],
  // C-反应蛋白
  C_reactive_protein: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 0.105
    },
    {
      key: 'mg/dL',
      scale: 0.105
    },
    {
      key: 'mg/100mL',
      scale: 0.0105
    },
    {
      key: 'mg%',
      scale: 0.0105
    },
    {
      key: 'μg/mL',
      scale: 0.0105
    },
    {
      key: 'g/L',
      scale: 0.0001
    }
  ],
  // 17-羟孕酮
  '17_α_hydroxy_progesterone': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.3305
    },
    {
      key: 'ng/dL',
      scale: 33.046
    },
    {
      key: 'ng/100mL',
      scale: 33.046
    },
    {
      key: 'ng%',
      scale: 33.046
    },
    {
      key: 'ng/L',
      scale: 330.46
    },
    {
      key: 'μg/L',
      scale: 0.3305
    }
  ],
  // 游离人绒毛膜促性腺激素β亚基（游离βhCG）
  βHCG: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'mIU/mL',
      scale: 1
    },
    {
      key: 'IU/L',
      scale: 1
    }
  ],
  // 游离前列腺特异性抗原
  Free_PSA: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'n/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 游离甲状腺素
  FT4: [
    {
      key: 'ng/dL',
      scale: 1
    },
    {
      key: 'ng/100mL',
      scale: 1
    },
    {
      key: 'ng%',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.01
    },
    {
      key: 'ng/L',
      scale: 10
    },
    {
      key: 'pg/mL',
      scale: 10
    },
    {
      key: 'pmol/L',
      scale: 12.872
    }
  ],
  // 游离雌三醇  1=100=100=100=1000=1
  E3: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 胰岛素样生长因子1
  IGF_1: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'μg/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.1
    },
    {
      key: 'μg/100mL',
      scale: 0.1
    },
    {
      key: 'μg%',
      scale: 0.1
    },
    {
      key: 'nmol/L',
      scale: 0.1307
    }
  ],
  // 雄烯二酮
  Androstenedione: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.2864
    },
    {
      key: 'ng/dL',
      scale: 28.64
    },
    {
      key: 'ng/100mL',
      scale: 28.64
    },
    {
      key: 'μg%',
      scale: 28.64
    },
    {
      key: 'ng/L',
      scale: 286.4
    },
    {
      key: 'μg/L',
      scale: 0.2864
    }
  ],
  // 胰岛素样生长因子结合蛋白3
  IGFBP_3: [
    {
      key: 'μg/mL',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 100
    },
    {
      key: 'μg/100mL',
      scale: 100
    },
    {
      key: 'μg%',
      scale: 100
    },
    {
      key: 'μg/L',
      scale: 1000
    },
    {
      key: 'mg/L',
      scale: 1
    }
  ],
  // 胰淀粉酶
  p_AMY: [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'nmol/(s·L)',
      scale: 1
    },
    {
      key: 'μmol/(s·L)',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    }
  ],
  // 乙醇脱氢酶
  ADH: [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'nmol/(s·L)',
      scale: 1
    },
    {
      key: 'μmol/(s·L)',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    }
  ],
  // 乙酰乙酸（乙酰乙酸盐）
  ACAC: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 10.2088
    },
    {
      key: 'mg/100mL',
      scale: 10.2088
    },
    {
      key: 'mg%',
      scale: 10.2088
    },
    {
      key: 'mg/L',
      scale: 102.088
    },
    {
      key: 'μg/mL',
      scale: 102.088
    }
  ],
  // 异丙醇
  Isopropanol: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 6.0096
    },
    {
      key: 'mg/100mL',
      scale: 6.0096
    },
    {
      key: 'mg%',
      scale: 6.0096
    },
    {
      key: 'mg/L',
      scale: 60.096
    },
    {
      key: 'μg/mL',
      scale: 60.096
    }
  ],
  // 癌胚抗原
  Carcinoembryonic_Antigen: [
    {
      key: 'μg/L',
      scale: 1
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/mL',
      scale: 1
    }
  ],
  // 胰岛素
  Insulin_Unit_Conversion: [
    {
      key: 'μIU/mL',
      scale: 1
    },
    {
      key: 'mlIU/L',
      scale: 1
    },
    {
      key: 'pmol/L',
      scale: 6
    }
  ],
  // 尿素
  Urea_unit_conversion: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 6.006
    },
    {
      key: 'mg/L',
      scale: 60.06
    },
    {
      key: 'μg/mL',
      scale: 60.06
    },
    {
      key: 'mg/100ml',
      scale: 6.006
    }
  ],
  // 肌酐
  Unit_conversionOfCreatinine: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 11.3126
    },
    {
      key: 'mg/L',
      scale: 113.126
    },
    {
      key: 'μg/mL',
      scale: 113.126
    },
    {
      key: 'mg/100ml',
      scale: 11.3126
    }
  ],
  // 红细胞
  RBC_UnitConversion: [
    {
      key: '10^9/L',
      scale: 1
    },
    {
      key: 'T/L',
      scale: 1
    },
    {
      key: 'Tpt/L',
      scale: 1
    },
    {
      key: '10^12 cells/L',
      scale: 1
    },
    {
      key: '10^6/μL',
      scale: 1
    },
    {
      key: '10^6/mm^3',
      scale: 1
    },
    {
      key: '10^6 cells/μL',
      scale: 1
    },
    {
      key: '10^6 cells/mm^3',
      scale: 1
    },
    {
      key: 'M/mm^3',
      scale: 1
    },
    {
      key: 'M/μL',
      scale: 1
    }
  ],
  // 白细胞
  WBC_UnitConversion: [
    {
      key: '10^9/L',
      scale: 1
    },
    {
      key: 'G/L',
      scale: 1
    },
    {
      key: 'Gpt/L',
      scale: 1
    },
    {
      key: '10^9 cells/L',
      scale: 1
    },
    {
      key: '10^3/μL',
      scale: 1
    },
    {
      key: '10^3/mm^3',
      scale: 1
    },
    {
      key: 'K/μL',
      scale: 1
    },
    {
      key: 'K/mm^3',
      scale: 1
    },
    {
      key: '10^3 cells/μL',
      scale: 1
    },
    {
      key: '10^3 cells/mm^3',
      scale: 1
    }
  ],
  // 钾（K）、钠（Na）单位换算关系
  Unit_conversion_of_common_ions: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'mEq/L',
      scale: 1
    }
  ],
  Unit_conversion_of_common_ions_ca: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mEq/L',
      scale: 2
    },
    {
      key: 'mg/dL',
      scale: 4.008
    },
    {
      key: 'mg/L',
      scale: 40.08
    },
    {
      key: 'μg/mL',
      scale: 40.08
    },
    {
      key: 'mg/100mL',
      scale: 4.008
    }
  ],
  Unit_conversion_of_common_ions_ma: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mEq/L',
      scale: 2
    },
    {
      key: 'mg/dL',
      scale: 2.431
    },
    {
      key: 'mg/L',
      scale: 24.31
    },
    {
      key: 'μg/mL',
      scale: 24.31
    },
    {
      key: 'mg/100mL',
      scale: 2.431
    }
  ],
  Unit_conversion_of_common_ions_fe: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mmol/L',
      scale: 0.001
    },
    {
      key: 'μg/dL',
      scale: 5.585
    },
    {
      key: 'μg/L',
      scale: 55.84
    },
    {
      key: 'ng/mL',
      scale: 55.85
    },
    {
      key: 'μg/100mL',
      scale: 5.584
    }
  ],
  Unit_conversion_of_common_ions_cu: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mmol/L',
      scale: 0.001
    },
    {
      key: 'μg/dL',
      scale: 6.355
    },
    {
      key: 'μg/L',
      scale: 63.55
    },
    {
      key: 'ng/mL',
      scale: 63.55
    },
    {
      key: 'μg/100mL',
      scale: 6.355
    }
  ],
  Unit_conversion_of_common_ions_zn: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mmol/L',
      scale: 0.001
    },
    {
      key: 'μg/dL',
      scale: 6.539
    },
    {
      key: 'μg/L',
      scale: 65.39
    },
    {
      key: 'ng/mL',
      scale: 65.39
    },
    {
      key: 'μg/100mL',
      scale: 6.539
    }
  ],
  Unit_conversion_of_common_ions_li: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: '10^3 μmol/L',
      scale: 1
    },
    {
      key: 'mEq/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.6941
    },
    {
      key: 'mg/L',
      scale: 6.941
    },
    {
      key: 'μg/mL',
      scale: 6.941
    },
    {
      key: 'mg/100mL',
      scale: 0.6941
    }
  ],
  Unit_conversion_of_common_ions_p: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: '10^3 μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 3.097
    },
    {
      key: 'mg/L',
      scale: 30.97
    },
    {
      key: 'μg/mL',
      scale: 30.97
    },
    {
      key: 'mg/100mL',
      scale: 3.097
    }
  ],
  IgE: [
    {
      key: 'IU/mL',
      scale: 1
    },
    {
      key: 'kU/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 2.42
    },
    {
      key: 'ng/dL',
      scale: 242
    },
    {
      key: 'ng/100mL',
      scale: 242
    },
    {
      key: 'μg/L',
      scale: 2.42
    }
  ],
  IgA: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 16
    },
    {
      key: 'mg/mL',
      scale: 0.16
    },
    {
      key: 'g/L',
      scale: 0.16
    },
    {
      key: 'mg/100mL',
      scale: 16
    }
  ],
  ammonia: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: '10^-3 mmol/L',
      scale: 1
    },
    {
      key: 'μg/L',
      scale: 17.03
    },
    {
      key: 'μg/dL',
      scale: 1.703
    },
    {
      key: 'μg/mL',
      scale: 0.01703
    },
    {
      key: 'mg/L',
      scale: 0.01703
    }
  ],
  Methanol: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/L',
      scale: 32.04
    },
    {
      key: 'mg/dL',
      scale: 3.204
    },
    {
      key: 'μg/mL',
      scale: 32.04
    },
    {
      key: 'mg/100mL',
      scale: 3.204
    }
  ],
  albumin: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'g/L',
      scale: 66.458
    },
    {
      key: 'g/dL',
      scale: 6.6458
    },
    {
      key: 'mg/mL',
      scale: 66.458
    },
    {
      key: 'g/100mL',
      scale: 6.6458
    }
  ],
  Gastrin_unit_conversion: [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'ng/L',
      scale: 2.098
    },
    {
      key: 'ng/dL',
      scale: 0.2098
    },
    {
      key: 'ng/100mL',
      scale: 0.2098
    },
    {
      key: 'pg/mL',
      scale: 2.098
    }
  ],
  // 雌二醇（E2）
  estradiol: [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'pg/L',
      scale: 272.386
    },
    {
      key: 'pg/dL',
      scale: 27.2386
    },
    {
      key: 'pg/mL',
      scale: 0.272386
    },
    {
      key: 'pg/100mL',
      scale: 27.2386
    },
    {
      key: 'ng/L',
      scale: 0.272386
    }
  ],
  // 白细胞介素-6（IL-6）
  IL_six: [
    {
      key: 'pg/mL',
      scale: 1
    },
    {
      key: 'ng/L',
      scale: 1
    },
    {
      key: 'pg/L',
      scale: 1000
    },
    {
      key: 'pg/dL',
      scale: 100
    },
    {
      key: 'pg/100mL',
      scale: 100
    }
  ],
  // 甲胎蛋白（AFP）
  AFP: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'μg/L',
      scale: 1
    },
    {
      key: 'IU/mL',
      scale: 0.83
    }
  ],
  // 类风湿因子（RF）
  RF: [
    {
      key: 'U/mL',
      scale: 1
    },
    {
      key: 'kU/L',
      scale: 1
    },
    {
      key: 'IU/mL',
      scale: 1
    },
    {
      key: 'kIU/L',
      scale: 1
    }
  ],
  // 乙醇
  ethanol: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/L',
      scale: 46.07
    },
    {
      key: 'mg/dL',
      scale: 4.607
    },
    {
      key: 'mg/100mL',
      scale: 4.607
    },
    {
      key: ' μg/mL',
      scale: 46.07
    }
  ],
  // 癌抗原15-3（CA15-3）
  Cancer_Antigen_15_3: [
    {
      key: 'kU/L',
      scale: 1
    },
    {
      key: 'U/mL',
      scale: 1
    }
  ],
  // 癌抗原19-9（CA19-9）
  Carbohydrate_Antigen_19_9: [
    {
      key: 'kU/L',
      scale: 1
    },
    {
      key: 'U/mL',
      scale: 1
    }
  ],
  // 总三碘甲状腺原氨酸（T3）
  Triiodothyronine: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.651
    },
    {
      key: 'ng/dL',
      scale: 65.0978
    },
    {
      key: 'ug/L',
      scale: 0.651
    }
  ],
  // 色氨酸(Trp)
  Tryptophan: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0204
    },
    {
      key: 'mg/100mL',
      scale: 0.0204
    },
    {
      key: 'mg%',
      scale: 0.0204
    },
    {
      key: 'mg/L',
      scale: 0.2042
    },
    {
      key: 'μg/mL',
      scale: 0.2042
    }
  ],
  // 神经元特异性烯醇化酶（NSE）
  Neuron_Specific_Enolase: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 生长分化因子-15（GDF-15）
  Growth_Differentiation_Factor_15: [
    {
      key: 'pg/mL',
      scale: 1
    },
    {
      key: 'pg/dL',
      scale: 100
    },
    {
      key: 'pg/100mL',
      scale: 100
    },
    {
      key: 'pg%',
      scale: 100
    },
    {
      key: 'pg/L',
      scale: 1000
    },
    {
      key: 'ng/L',
      scale: 1
    }
  ],
  // 生物素(维生素B7)
  Biotin: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 240
    },
    {
      key: 'ng/L',
      scale: 240
    },
    {
      key: 'ng/dL',
      scale: 24
    },
    {
      key: 'ng%',
      scale: 24
    }
  ],
  // 视黄醇（维生素A）
  Retinol: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 28
    },
    {
      key: 'μg/100mL',
      scale: 28
    },
    {
      key: 'μg%',
      scale: 28
    },
    {
      key: 'μg/L',
      scale: 280
    },
    {
      key: 'ng/mL',
      scale: 280
    }
  ],
  // 水杨酸盐
  Salicylate: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 13.81
    },
    {
      key: 'mg/100mL',
      scale: 13.81
    },
    {
      key: 'mg%',
      scale: 13.81
    },
    {
      key: 'ng/mL',
      scale: 138.1
    },
    {
      key: 'ng/mL',
      scale: 138.1
    }
  ],
  // 丝氨酸
  Serine: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0105
    },
    {
      key: 'mg/100mL',
      scale: 0.0105
    },
    {
      key: 'mg%',
      scale: 0.0105
    },
    {
      key: 'mg/mL',
      scale: 0.1051
    },
    {
      key: 'μg/mL',
      scale: 0.1051
    }
  ],
  // 苏氨酸（Thr）
  Threonine: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0119
    },
    {
      key: 'mg/100mL',
      scale: 0.0119
    },
    {
      key: 'mg%',
      scale: 0.0119
    },
    {
      key: 'mg/L',
      scale: 0.1191
    },
    {
      key: 'μg/mL',
      scale: 0.1191
    }
  ],
  // 酸性磷酸酶（ACP）
  Acid_Phosphatase: [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min•L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h•L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h•mL)',
      scale: 0.0036
    }
  ],
  // 糖化血红蛋白（HbA1c）与平均血糖（eAG）的换算
  Hemoglobin_A1c: [
    {
      key: 'HbA<sub>1c</sub>(mmol/mol)',
      scale: 1
    },
    {
      key: 'HbA<sub>1c</sub>(%)',
      scale: 2.2
    },
    {
      key: 'eAG(mg/dL)',
      scale: 17.64
    },
    {
      key: 'eAG(mmol/mol)',
      scale: 0.98
    }
  ],
  // 胎盘生长因子（PIGF）
  Placental_Growth_Factor: [
    {
      key: 'pg/mL',
      scale: 1
    },
    {
      key: 'pg/dL',
      scale: 100
    },
    {
      key: 'pg/100mL',
      scale: 100
    },
    {
      key: 'pg%',
      scale: 100
    },
    {
      key: 'pg/L',
      scale: 1000
    },
    {
      key: 'ng/L',
      scale: 1
    }
  ],
  // 碳酸氢盐（HCO3-）
  Bicarbonate: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mEq/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 6.1017
    },
    {
      key: 'mg/100mL',
      scale: 6.1017
    },
    {
      key: 'mg%',
      scale: 6.1017
    },
    {
      key: 'mg/L',
      scale: 61.0168
    },
    {
      key: 'μg/mL',
      scale: 61.0168
    }
  ],
  // 天冬氨酸（Asp）
  Aspartic_Acid: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0133
    },
    {
      key: 'mg/100mL',
      scale: 0.0133
    },
    {
      key: 'mg%',
      scale: 0.0133
    },
    {
      key: 'mg/L',
      scale: 0.1331
    },
    {
      key: 'μg/mL',
      scale: 0.1331
    }
  ],
  // 天冬氨酸氨基转移酶（AST/SGOT）
  Aspartate_Aminotransferase: [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min•L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h•L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h•mL)',
      scale: 0.0036
    }
  ],
  // 天冬酰胺（Asn）
  Asparagine: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0132
    },
    {
      key: 'mg/100mL',
      scale: 0.0132
    },
    {
      key: 'mg%',
      scale: 0.0132
    },
    {
      key: 'mg/L',
      scale: 0.1321
    },
    {
      key: 'μg/mL',
      scale: 0.1321
    }
  ],
  // 铁蛋白
  Ferritin: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'pmol/L',
      scale: 1000
    },
    {
      key: 'μg/dL',
      scale: 44.5
    },
    {
      key: 'μg/100mL',
      scale: 44.5
    },
    {
      key: 'μg%',
      scale: 44.5
    },
    {
      key: 'μg/L',
      scale: 445
    },
    {
      key: 'ng/mL',
      scale: 445
    }
  ],
  // 铜蓝蛋白（CP）
  Ceruloplasmin: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'g/L',
      scale: 134
    },
    {
      key: 'mg/dL',
      scale: 13400
    },
    {
      key: 'mg/100mL',
      scale: 13400
    },
    {
      key: 'mg%',
      scale: 13400
    },
    {
      key: 'mg/mL',
      scale: 134
    }
  ],
  // 维生素C（抗坏血酸）
  Ascorbic_Acid: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0176
    },
    {
      key: 'mg/100mL',
      scale: 0.0176
    },
    {
      key: 'mg%',
      scale: 0.0176
    },
    {
      key: 'mg/L',
      scale: 0.1761
    },
    {
      key: 'μg/mL',
      scale: 0.1761
    }
  ],
  // 维生素D总量
  Total_Vitamin_D: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.4
    },
    {
      key: 'ng/dL',
      scale: 40
    },
    {
      key: 'ng/100mL',
      scale: 40
    },
    {
      key: 'ng%',
      scale: 40
    },
    {
      key: 'ng/L',
      scale: 400
    },
    {
      key: 'μg/L',
      scale: 0.4
    }
  ],
  // 维生素B1（硫胺素）
  Thiamine: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.0337
    },
    {
      key: 'μg/100mL',
      scale: 0.0337
    },
    {
      key: 'μg%',
      scale: 0.0337
    },
    {
      key: 'μg/L',
      scale: 0.3373
    },
    {
      key: 'ng/mL',
      scale: 0.3373
    }
  ],
  // 维生素B3（烟酸）
  Niacin: [
    {
      key: 'μg/dL',
      scale: 1
    },
    {
      key: 'μg/100mL',
      scale: 1
    },
    {
      key: 'μg%',
      scale: 1
    },
    {
      key: 'μg/L',
      scale: 10
    },
    {
      key: 'ng/mL',
      scale: 10
    },
    {
      key: 'μg/mL',
      scale: 0.01
    }
  ],
  // 维生素B6（磷酸吡哆醛）
  Pyridoxine: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.0247
    },
    {
      key: 'μg/100mL',
      scale: 0.0247
    },
    {
      key: 'μg%',
      scale: 0.0247
    },
    {
      key: 'μg/L',
      scale: 0.2471
    },
    {
      key: 'ng/mL',
      scale: 0.2471
    }
  ],
  // 维生素B12（氰钴胺）
  Cobalamin: [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 1.3554
    },
    {
      key: 'pg/dL',
      scale: 135.537
    },
    {
      key: 'pg/100mL',
      scale: 135.537
    },
    {
      key: 'pg%',
      scale: 135.537
    },
    {
      key: 'pg/L',
      scale: 1355.37
    },
    {
      key: 'ng/L',
      scale: 1.3554
    }
  ],
  // 妥布霉素
  Tobramycin: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0468
    },
    {
      key: 'mg/100mL',
      scale: 0.0468
    },
    {
      key: 'mg%',
      scale: 0.0468
    },
    {
      key: 'mg/L',
      scale: 0.4675
    },
    {
      key: 'μg/mL',
      scale: 0.4675
    }
  ],
  // 万古霉素
  Vancomycin: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.1449
    },
    {
      key: 'mg/100mL',
      scale: 0.1449
    },
    {
      key: 'mg%',
      scale: 0.1449
    },
    {
      key: 'mg/L',
      scale: 1.4493
    },
    {
      key: 'μg/mL',
      scale: 1.4493
    }
  ],
  // 1,25-二羟基维生素D3（骨化三醇）
  Calcitriol: [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 0.4166
    },
    {
      key: 'ng/dL',
      scale: 0.0417
    },
    {
      key: 'ng/100mL',
      scale: 0.0417
    },
    {
      key: 'ng%',
      scale: 0.0417
    },
    {
      key: 'ng/L',
      scale: 0.4166
    }
  ],
  // 25-羟基维生素D3（25-羟基维生素D）
  '25_Hydroxyvitamin_D': [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'nmol/L',
      scale: 2.496
    },
    {
      key: 'μg/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.1
    },
    {
      key: 'μg/100mL',
      scale: 0.1
    }
  ],
  // 维生素E（α-生育酚）
  Vitamin_E: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0431
    },
    {
      key: 'mg/100mL',
      scale: 0.0431
    },
    {
      key: 'mg%',
      scale: 0.0431
    },
    {
      key: 'mg/L',
      scale: 0.4307
    },
    {
      key: 'μg/mL',
      scale: 0.0431
    }
  ],
  // 维生素K（叶绿醌）
  Phylloquinone: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.0451
    },
    {
      key: 'μg/100mL',
      scale: 0.0451
    },
    {
      key: 'μg%',
      scale: 0.0451
    },
    {
      key: 'μg/L',
      scale: 0.4507
    },
    {
      key: 'ng/mL',
      scale: 0.4507
    }
  ],
  // 胃泌素释放肽前体（ProGRP）
  Pro_gastrin_releasing_peptide: [
    {
      key: 'pg/mL',
      scale: 1
    },
    {
      key: 'pg/dL',
      scale: 100
    },
    {
      key: 'pg/100mL',
      scale: 100
    },
    {
      key: 'pg%',
      scale: 100
    },
    {
      key: 'pg/L',
      scale: 1000
    },
    {
      key: 'ng/L',
      scale: 1
    }
  ],
  // 硒代半胱氨酸（Sec）
  Selenocysteine: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0168
    },
    {
      key: 'mg/100mL',
      scale: 0.0168
    },
    {
      key: 'mg%',
      scale: 0.0168
    },
    {
      key: 'mg/L',
      scale: 0.1681
    },
    {
      key: 'μg/mL',
      scale: 0.1681
    }
  ],
  // 细胞角蛋白19片段（CYFRA 21-1）
  Cytokeratin_19_Fragment: [
    {
      key: 'μg/mL',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.1
    },
    {
      key: 'μg/100mL',
      scale: 0.1
    },
    {
      key: 'ng%',
      scale: 0.1
    },
    {
      key: 'ng/mL',
      scale: 1
    }
  ],
  // 镁
  Magnesium: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/L',
      scale: 24.305
    },
    {
      key: 'mg/dL',
      scale: 2.4305
    },
    {
      key: 'mg/100mL',
      scale: 2.4305
    },
    {
      key: 'μg/mL',
      scale: 24.305
    },
    {
      key: 'mEg/L',
      scale: 2
    }
  ],
  // 胰高血糖素
  Glucagon: [
    {
      key: 'ng/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 0.1
    },
    {
      key: 'ng/100mL',
      scale: 0.1
    },
    {
      key: 'ng%',
      scale: 0.1
    }
  ]
}
export default scoreFilterJson



// WEBPACK FOOTER //
// ./src/utils/filter/scoreFilter.js